module.exports = __webpack_public_path__ + "media/veracruz/ConvocatoriaTorneoAjedrez-812efa78.png";